import { Stack, VStack } from "@chakra-ui/react";
import React from "react";
import useThemeColors from "../../hooks/useThemeColors";
import CustomButton from "./CustomButton";
import FormNavigationLinks from "./FormNavigationLinks";
import PasswordInput from "./CustomPasswordInput";
import useIcons from "../../hooks/useIcons";

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: any;
  handleNextStep: (e: React.FormEvent) => void;
  handlePreviousStep: () => void;
  loading: boolean;
  password?: string;
  confirmPassword?: string;
  isNextDisabled?: boolean;
}

function AuthRegForm({
  handleChange,
  errors,
  handleNextStep,
  handlePreviousStep,
  loading,
  password,
  confirmPassword,
  isNextDisabled = false,
}: Props) {
  const colors = useThemeColors();
  const icons = useIcons();

  return (
    <VStack w={"full"}>
      <form onSubmit={handleNextStep} style={{ width: "100%" }}>
        <Stack gap={4}>
          <PasswordInput
            placeholder="Password *"
            name="password"
            value={password || ""}
            onChange={handleChange}
            invalid={!!errors.password}
            error={errors.password}
            required
          />

          <PasswordInput
            placeholder="Confirm Password *"
            name="confirmPassword"
            value={confirmPassword || ""}
            onChange={handleChange}
            invalid={!!errors.confirmPassword}
            error={errors.confirmPassword}
            required
          />

          <CustomButton
            w={"full"}
            type="submit"
            label="Next"
            loading={loading}
            disabled={loading || isNextDisabled}
            colorPalette={colors.brand.primary}
          />
          <FormNavigationLinks
            links={[
              {
                text: "Go Back",
                onClick: handlePreviousStep,
                icon: icons.utility.arrowLeft,
                isDisabled: loading,
              },
            ]}
          />
        </Stack>
      </form>
    </VStack>
  );
}

export default AuthRegForm;
